import React from "react";
import { useIntl } from "react-intl";
import { TableCell, TableRow } from "@material-ui/core";

const RelatedServiceProviderTableEmptyRow = ({}) => {
  const intl = useIntl();

  return (
    <TableRow>
      <TableCell colSpan={4}>
        <span
          style={{
            color: "grey",
          }}
        >
          {intl.formatMessage({
            id: "app.userProfile.relatedServiceProviders.empty",
          })}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default RelatedServiceProviderTableEmptyRow;
